import { render } from "./UserAgreementModal.vue?vue&type=template&id=3b388e5f"
import script from "./UserAgreementModal.vue?vue&type=script&lang=js"
export * from "./UserAgreementModal.vue?vue&type=script&lang=js"

import "./UserAgreementModal.vue?vue&type=style&index=0&id=3b388e5f&lang=scss"
/* custom blocks */
import block0 from "./UserAgreementModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__